import { promiseState } from 'annotation-tools/utils';
import { ListItemWithPromiseState } from './list-item-with-status';

export const isItemNotFoundError = <T>(
  item: ListItemWithPromiseState<T>
): boolean =>
  item.status === promiseState.error && item.value.reason === 'item-not-found';
